export default __webpack_public_path__ + "static/User-669db8ff0aee3b1cfa48cdbd273a2a67.png";